const defaultDeleteMode = false;
export default (state = defaultDeleteMode, action) => {
  switch (action.type) {
    case 'ENABLE_DELETE_MODE':
      return true;
    case 'DISABLE_DELETE_MODE':
      return false;
    default:
      return state;
  }
};
